import api from "./api";

/* GET ADMINS */
export const getAllAdmins = async () => {
    const res = await api.get("/admin");
    return res.data;
};

/* GET USERS */
export const getAllUsers = async () => {
    const res = await api.get("/admin/users");
    return res.data;
};

/* DISABLE 2FA */
export const disableUserTwoFactor = async (userId) => {
    const res = await api.post(`/admin/users/${userId}/disable-2fa`);
    return res.data;
};

/* CHANGE ROLE */
export const changeUserRole = async (userId, roleId) => {
    const res = await api.put(`/admin/users/${userId}/change-role`, {
        roleId: Number(roleId),
    });
    return res.data;
};

/* DELETE ADMIN */
export const deleteAdmin = async (adminId) => {
    const res = await api.delete(`/admin/${adminId}`);
    return res.data;
};

export default {
    getAllAdmins,
    getAllUsers,
    disableUserTwoFactor,
    changeUserRole,
    deleteAdmin,
};